import React, { createContext, useContext } from 'react';
import { useMediaQuery } from '../hooks';

const ResponsiveContext = createContext(null);

export function useResponsive() {
  const context = useContext(ResponsiveContext);

  if (context === null) {
    throw new Error('useResponsive must be used within a ResponsiveProvider');
  }

  return context;
}

export const ResponsiveProvider = ({ children }) => {
  const isMobile = useMediaQuery('mobile');
  const isTablet = useMediaQuery('tablet');
  const isDesktop = useMediaQuery('desktop');

  return (
    <ResponsiveContext.Provider value={{ isMobile, isTablet, isDesktop }}>
      {children}
    </ResponsiveContext.Provider>
  );
};
